export var UnitOfTime;
(function (UnitOfTime) {
    UnitOfTime["Day"] = "day";
    UnitOfTime["Week"] = "week";
})(UnitOfTime || (UnitOfTime = {}));
//# sourceMappingURL=unit-of-time.js.map